import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/Alerts/BulletinAlert.js");
;
import(/* webpackMode: "eager", webpackExports: ["TealButton"] */ "/Users/ilias/Github/talnet.co/src/components/Atoms/Buttons/ColorButtons.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Molecules/AvatarImage.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Molecules/JobAlertBox.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Molecules/JobShareBox.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Modals/CandidateModal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Modals/SubmissionModalJob.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Modals/SubmissionModalWorkspace.js");
